<template>
    <div>
        <h4 v-if="published === null" class="text-center">Dashboard</h4>
        <form>
            <div v-if="published === null" class="form-group row dash-panel"
                 v-bind:style="{borderColor: selectedPanelBackgroundColor}">
                <label class="col-sm-1 col-form-label" for="searchpanelselect">Search Criteria</label>
                <select class="col-sm-3 form-control" id="searchpanelselect" v-model="selectedPanelId"
                        @change="changeSearchPanelSelection($event)">
                    <option v-for="panel in panels" v-bind:key="panel.panelId" :value="panel.panelId">
                        {{ panel.name }}
                    </option>
                </select>
                <label class="col-sm-1 col-form-label" for="graphTypeselect">Graph Types</label>
                <select class="col-sm-3 form-control" id="graphTypeselect" v-model="graphType">
                    <optgroup v-for="(names, group) in graphTypesAvailable" v-bind:key="group" :label="`${group}`">
                        <option v-for="option in names" v-bind:key="option.value" :value="option.value">
                            {{ option.text }}
                        </option>
                    </optgroup>
                </select>
                <b-button class="col-sm-1" variant="info" v-on:click="addGraph">Add Graph</b-button>
                <b-button class="col-sm-1 ml-4" variant="warning" v-on:click="resetDashboardLayoutAndRedraw">Reset
                    Layout
                </b-button>

            </div>

            <div v-if="(user) && (published === null) " class="form-group row">
                <label class="col-sm-1 col-form-label" for="dashboard-name-input">Dashboard</label>
                <input class="col-sm-3 form-control" id="dashboard-name-input" v-model="settingsName"
                       placeholder="Untitled">
                <b-button class="col-sm-1" variant="info" v-on:click="saveDashboardSettings">Save</b-button>
                <label class="col-sm-1 col-form-label" for="dashboard-available-select">Available</label>
                <select class="col-sm-3 form-control" id="dashboard-available-select" v-model="settingsSelected">
                    <optgroup v-for="(settings, group) in settingsAvailable" v-bind:key="group" :label="`${group}`">
                        <option v-for="setting in settings" v-bind:key="setting.id" :value="setting.id">
                            {{ setting.name }}
                        </option>
                    </optgroup>
                </select>
                <b-button class="col-sm-1" variant="info" v-on:click="loadDashboardSettings">Load</b-button>
            </div>

        </form>
        <grid-layout :layout="dashboardConfig"
                     :col-num="12" :row-height="30" :is-draggable="draggable" :is-resizable="resizable"
                     :is-mirrored="false" :vertical-compact="true" :margin="[5, 5]"
                     :use-css-transforms="true">
            <grid-item class="rounded-card"
                       :static="item.static"
                       drag-allow-from=".vue-draggable-handle"
                       drag-ignore-from=".no-drag"
                       v-for="(item, index) in dashboardConfig" :key="item.i"
                       :autoSize="true" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i">

                <div>
                    <div class="rounded-top" v-bind:style="{ backgroundColor: item.backgroundColor, height : '24px'}">
                        <p class="vue-draggable-handle">
                            <i class="bi bi-arrows-move" v-bind:style="{ marginLeft: '10px'}"></i>
                        </p>
                    </div>
                    <span class="remove"><i class="bi bi-x-circle-fill" v-bind:style="{ marginRight: '10px'}"
                                            @click="removeDashboardWidget(item.i)"></i></span>
                    <div class="no-drag">

                        <SummaryWidget v-if="item.type === 'summary'"
                                       :panelId="item.panelId"
                                       :componentId="item.i"
                                       :triggerValue="item.triggerValue"
                                       is-draggable="isDraggable">
                        </SummaryWidget>

                        <ScatterPlot v-if="item.type === 'scatterplot'"
                                     :panelId="item.panelId"
                                     :componentId="item.i"
                                     :triggerValue="item.triggerValue"
                                     :settings="item.settings"
                                     is-draggable="isDraggable">
                        </ScatterPlot>

                        <TemporalDiscreteGraph name="season" v-if="item.type ==='temporaldiscretegraph'"
                                               :panelId="item.panelId"
                                               :componentId="item.i"
                                               :triggerValue="item.triggerValue"
                                               :settings="item.settings"
                                               is-draggable="isDraggable">
                        </TemporalDiscreteGraph>

                        <DateGraph name="date" v-if="item.type ==='dategraph'"
                                   :panelId="item.panelId"
                                   :componentId="item.i"
                                   :triggerValue="item.triggerValue"
                                   :settings="item.settings"
                                   is-draggable="isDraggable">
                        </DateGraph>


                        <TreemapGraph name="treemap" v-if="item.type ==='treemap'"
                                      :panelId="item.panelId"
                                      :componentId="item.i"
                                      :triggerValue="item.triggerValue"
                                      :settings="item.settings"
                                      is-draggable="isDraggable">

                        </TreemapGraph>

                        <NormalizedBarChart name="barchart" v-if="item.type ==='barchart'"
                                            :panelId="item.panelId"
                                            :componentId="item.i"
                                            :triggerValue="item.triggerValue"
                                            :settings="item.settings"
                                            is-draggable="isDraggable">

                        </NormalizedBarChart>


                        <MapWidget name="map" v-if="item.type ==='map'"
                                   :panelId="item.panelId"
                                   :componentId="item.i"
                                   :triggerValue="item.triggerValue"
                                   :settings="item.settings"
                                   is-draggable="isDraggable" v-bind:style="{ position: 'relative' }"></MapWidget>

                        <PcRepartition name="pc_repartition" v-if="item.type ==='pc_repartition'"
                                       :panelId="item.panelId"
                                       :componentId="item.i"
                                       :triggerValue="item.triggerValue"
                                       :settings="item.settings"
                                       is-draggable="isDraggable">

                        </PcRepartition>


                        <Sunburst name="sunburst" v-if="item.type ==='sunburst'"
                                  :panelId="item.panelId"
                                  :componentId="item.i"
                                  :triggerValue="item.triggerValue"
                                  :settings="item.settings"
                                  is-draggable="isDraggable">
                        </Sunburst>

                        <Placeholder v-if="item.type === 'placeholder'" :item="item" :itemIndex="index"></Placeholder>

                        <BetaDiversityDissimilarity v-if="item.type === 'scatterbetanmds'"
                                                    :panelId="item.panelId"
                                                    :componentId="item.i"
                                                    :triggerValue="item.triggerValue"
                                                    :settings="item.settings"
                                                    is-draggable="isDraggable">
                        </BetaDiversityDissimilarity>

                        <AlphaDiversity v-if="item.type === 'alpha_div'"
                                        :panelId="item.panelId"
                                        :componentId="item.i"
                                        :triggerValue="item.triggerValue"
                                        :settings="item.settings"
                                        is-draggable="isDraggable">
                        </AlphaDiversity>

                    </div>
                </div>
            </grid-item>
        </grid-layout>
    </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import {mapActions, mapGetters} from "vuex";
import {GridItem, GridLayout} from "vue-grid-layout";
import Placeholder from "./Placeholder";
import TemporalDiscreteGraph from "./TemporalDiscreteGraph";
import DateGraph from "./DateGraph";
import ScatterPlot from "./ScatterPlot";
import TreemapGraph from "./TreemapGraph";
import SummaryWidget from "./SummaryWidget";
import MapWidget from "./MapWidget";
import NormalizedBarChart from "./NormalizedBarChart";
import PcRepartition from "./PcRepartition";
import Sunburst from "./Sunburst";
import BetaDiversityDissimilarity from "./BetaDiversityDissimilarity";
import AlphaDiversity from "./AlphaDiversity.vue";


export default {
    components: {
        NormalizedBarChart,
        GridLayout,
        GridItem,
        DateGraph,
        TemporalDiscreteGraph,
        MapWidget,
        ScatterPlot,
        TreemapGraph,
        SummaryWidget,
        Placeholder,
        PcRepartition,
        Sunburst,
        BetaDiversityDissimilarity,
        AlphaDiversity
    },

    props: ['user', "dashId", "published"],

    data: function () {
        return {
            draggable: true,
            resizable: true,

            graphType: "summary",

            settingsName: "MyGOD Settings",
            settingsSelected: "",
            settingsAvailable: [],

        }
    },

    watch: {

        selectedPanelId() {
            return this.getSelectedPanel.panelId
        },

        selectedPanelBackgroundColor() {
            return this.getSelectedPanel.backgroundColor
        },

    },

    computed: {
        ...mapGetters([
            'getDashboardConfig',
            'getAvailablePanels',
            'getSelectedPanel',
            'getAvailableGraphTypes'
        ]),

        selectedPanelId() {
            return this.getSelectedPanel.panelId
        },

        selectedPanelBackgroundColor() {
            return this.getSelectedPanel.backgroundColor
        },

        dashboardConfig() {
            return this.getDashboardConfig
        },

        panels() {
            return this.getAvailablePanels
        },

        graphTypesAvailable() {
            return this.getAvailableGraphTypes
        },


    },

    created() {
        this.initDashboard()
        this.getAvailableDashboardSettings()
    },

    mounted() {
        if (this.dashId != null) {
            this.settingsSelected = this.dashId
            this.loadSettings(this.settingsSelected)

        }
    },

    methods: {
        ...mapActions([
            'clearDashboard',
            'initDashboard',
            'addDashboardWidget',
            'removeDashboardWidget',
            'resetDashboardLayout',
            'searchPanelSelectionChanged',
            'saveSettings',
            'loadSettings',
        ]),

        addGraph: function () {
            this.addDashboardWidget({type: this.graphType});
        },


        disableGrid() {
            this.isDraggable = !this.isDraggable
            this.isResizable = !this.isResizable
            this.preview = !this.preview
            this.contenteditable = !this.contenteditable
        },

        /**
         * Called when the user selects a new entry in theSearch Criteria option list (i.e. changes the
         * currently 'active' TaxonSearchPanel). It mainly updates the selected_panel in the Vuex store.
         * @param event the event with the information about the newly selected option.
         */
        changeSearchPanelSelection: function (event) {
            let payload = {}
            payload.panelId = event.target.value
            this.searchPanelSelectionChanged(payload)
        },

        /**
         * Called when the user clicks on the Reset Layout button.
         * All widgets are repositioned and resized in a 4 column grid.
         */
        resetDashboardLayoutAndRedraw: function () {
            this.resetDashboardLayout()
        },

        /**
         * Called when the user clicks on the Save button of the dashboard control panel.
         */
        saveDashboardSettings: function () {
            let payload = {'name': this.settingsName, 'info': null}
            for (const [key, settings] of Object.entries(this.settingsAvailable)) {
                for (let index = 0; index < settings.length; index++) {
                    if (this.settingsName === settings[index].id) {
                        payload['info'] = settings[index]
                    }
                }
            }
            this.saveSettings(payload)
            this.getAvailableDashboardSettings()
        },

        /**
         * Helper function to allow waiting before retrieving
         * the list of available settings.
         * @param seconds the number of seconds to wait before retrying
         * @returns {Promise<unknown>}
         */
        delayRefreshDashboardSettingsMenu(seconds) {
            return new Promise(function (resolve) {
                setTimeout(resolve, seconds * 1000)
            })
        },

        /**
         * Helper function ensuring no settings are currently saved before
         * retrieving the list of available settings.
         * @returns {Promise<void>}
         */
        async refreshDashboardSettingsMenu() {
            /*
            The state.saving flag of the store is modified by the saveSettings mutation.
             */
            while (this.$store.state.saving === true) {
                await this.delayRefreshDashboardSettingsMenu(1)
            }
            axios
                .get(encodeURI(this.$store.state.apiRootPath + 'settings/'))
                .then(response => {
                    this.settingsAvailable = response.data
                    if (this.settingsAvailable.length > 0) {
                        for (let index = 0; index < this.settingsAvailable.length; index++) {
                            let dateObj = new Date(this.settingsAvailable[index].creationdate)
                            let creationdate = dateObj.toLocaleString()
                            dateObj = new Date(this.settingsAvailable[index].lastsaved)
                            let lastsaved = dateObj.toLocaleString()
                            this.settingsAvailable[index].title = "Created on " + creationdate
                                + " -- " + "Last saved on " + lastsaved
                        }
                        let owned_dashboard = Object.values(this.settingsAvailable)[0];
                        this.settingsSelected = owned_dashboard[0].id
                    }
                })
                .catch(function (error) {
                    console.warn("Unable to retrieve settings names: " + error);
                })

        },

        /**
         * Called to fill the dropdown menu with the already saved settings.
         */
        getAvailableDashboardSettings: function () {
            /**
             * When saving the settings, the POST request can take some time.
             * Refreshing the menu with the list of available settings needs to
             * ensure that no settings are being currently saved.
             * Hence the use of the async/await functions above.
             */
            this.refreshDashboardSettingsMenu()
        },

        /**
         * Called when the user clicks on the Load button of the dashboard control panel.
         */
        loadDashboardSettings() {
            this.clearDashboard()
            this.loadSettings(this.settingsSelected)
            for (const [key, settings] of Object.entries(this.settingsAvailable)) {
                for (let index = 0; index < settings.length; index++) {
                    if (this.settingsSelected === settings[index].id) {
                        this.settingsName = settings[index].name
                    }
                }
            }
        },

    }
}
</script>
<style>
.rounded-card {
    border-radius: 5px;
}

#dashboard {
    background: #aab7bf !important;
    /*border: 1px solid black;*/
    margin-top: 10px;
    padding: 10px;
}

.columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
}

/*************************************/
.remove {
    position: absolute;
    right: 2px;
    top: 0;
    cursor: pointer;
    color: white;
    font-size: medium;
}

.vue-grid-layout {
    background: #aab7bf !important;
    min-height: 200px;
}


.vue-grid-item.vue-grid-placeholder {
    background: #e8860e !important;
    opacity: 0.6 !important;
}

.vue-grid-item:not(.vue-grid-placeholder) {
    background: #ffffff;
    border: 1px solid white;
}

.vue-grid-item .resizing {
    opacity: 0.9;
}

.vue-grid-item .static {
    background: #cce;
}

.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}

.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}

.vue-grid-item .minMax {
    font-size: 12px;
}

.vue-grid-item .add {
    cursor: pointer;
}

.text-darkblue {
    color: #005B60 !important;
    text-align: left;
}

.vue-draggable-handle {
    position: initial;
    width: 5px;
    height: 5px;
    top: 0;
    right: 0;
    padding: 0 8px 8px 0;
    background-origin: content-box;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    color: white !important;
}

.background-control-group {
    background: #dde6eb !important;
}

.legend {
    font-size: small;
}

.legend-height {
    line-height: 1 !important;
}

.dash-panel {
    border-width: 4px;
    border-style: solid;
    padding: 10px;
    margin: 10px;
}


</style>

